import { memo, useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { RoutePath } from 'consts/RoutePath';
import { GroupWithLoginUser, LeaveFamilyReqData, callLeaveFamilyApi } from 'requests/RequestGroup';
import { Hr } from 'components/atoms/Hr';
import classes from './override.module.scss';
import { findGroupAuthByKey } from 'consts/GroupAuthConst';
import { HttpStatus } from 'consts/HttpStatus';
import { CircularProgress } from '@material-ui/core';
import { ApiError } from 'requests/RequestBase';
import { BirthDay } from 'components/molecules/BirthDay';

type Props = {};
type LeaveFamilyOnlyDto = {
	group: GroupWithLoginUser;
};

export const LeaveFamilyOnlyTemplate = memo((_props: Props) => {
	const history = useHistory<LeaveFamilyOnlyDto>();
	const dto = history.location.state;
	const myselfAuth = findGroupAuthByKey(dto.group.loginUser);
	const [page, setPage] = useState(0);
	const [processLoading, setProcessLoading] = useState(false);
	const [actionError, setActionError] = useState('');
	const isActionError = actionError !== '';

	const [timer, setTimer] = useState(undefined);
	const backToMyPage = () => {
		clearTimeout(timer);
		history.push(RoutePath.MY_PAGE);
	};
	const leaveFamily = async () => {
		setProcessLoading(true);
		// 家族から抜ける
		const body: LeaveFamilyReqData = {
			group_name: '家族',
		};
		const result = await callLeaveFamilyApi(dto.group.group_id, body);
		if (result.status !== HttpStatus.OK) {
			const errorData = result.data as ApiError;
			setActionError(errorData.message);
			setProcessLoading(false);
			return;
		}
		setProcessLoading(false);

		const timer = setTimeout(function () {
			history.push(RoutePath.MY_PAGE);
		}, 5000);
		setTimer(timer);

		setPage((prev) => prev + 1);
	};

	const scrollRef = useRef(null);
	useEffect(() => {
		scrollRef.current.scrollIntoView();
		document.title = '「家族」から抜ける';
	}, []);

	const errorRef = useRef(null);
	useEffect(() => {
		if (isActionError) {
			errorRef.current.scrollIntoView();
		}
	}, [actionError]);

	return (
		<>
			<section className="section mypage" ref={scrollRef}>
				<div className="breadcrumb">
					<ul>
						<li>
							<Link to={RoutePath.MY_PAGE}>マイページTOP</Link>
						</li>
						<li>
							<Link to={RoutePath.FAMILY_INFO}>家族情報</Link>
						</li>
						<li>「家族」から抜ける</li>
					</ul>
				</div>
				<h1 className="page-head">「家族」から抜ける</h1>
				{page === 0 && (
					<div className="section-in" style={{ marginTop: 50 }}>
						<div className="section-head error-box">
							<p>注意事項をご確認ください</p>
						</div>
						<div className="section-txt-box">
							<div className="txt">
								<ul>
									<li>現在ご利⽤いただいているサービスは、引き続きご利⽤いただけます</li>
									<li>「家族」に所属している「ユーザーの確認」ができなくなります</li>
									<li>「家族」に所属している「ユーザーの管理」ができなくなります</li>
								</ul>
							</div>
						</div>

						{isActionError ? (
							<div className="error-box" ref={errorRef}>
								<p>{actionError}</p>
							</div>
						) : null}

						<div className="info-box" style={{ marginTop: 50 }}>
							<Hr />
							<div className={classes.memberRow}>
								<div className={`${classes.memberRowDataColumn} ${classes.iconColumn} ${classes.iconDataColumn}`}>
									<span className={classes.selectRepresentativeIcon}>あなた</span>
								</div>
								<div className={`${classes.memberRowDataColumn} ${classes.iconColumn} ${classes.iconDataColumn}`}>
									<img className={classes.memberIcon} src={`images/${myselfAuth.image}`} alt="" />
									<div className={classes.memberLabel}>{myselfAuth.name}</div>
								</div>
								<div
									className={`${classes.memberRowDataColumn} ${classes.nameColumn} ${classes.nameDataColumn}`}
								>{`${dto.group.loginUser.lastname}　${dto.group.loginUser.firstname}`}</div>
								<div className={`${classes.memberRowDataColumn} ${classes.birthColumn} ${classes.birthDataColumn}`}>
									<BirthDay birth={dto.group.loginUser.birth} />
								</div>
							</div>
							<Hr />
						</div>
						<div className="btn-box">
							{processLoading ? (
								<CircularProgress />
							) : (
								<>
									<div className="btn wh">
										<Link to={{ pathname: RoutePath.LEAVE_FAMILY, state: dto }}>
											<span>戻る</span>
										</Link>
									</div>
									<div className="btn gr">
										<button onClick={leaveFamily}>「家族」から抜ける</button>
									</div>
								</>
							)}
						</div>
					</div>
				)}
				{page === 1 && (
					<div className="section-in" style={{ marginTop: 50 }}>
						<div className="thankyou-box">
							<img src="images/img-complete.svg" alt="完了しました" />
						</div>
						<p>
							<div>5秒後に自動的にマイページTOPへ戻ります</div>
						</p>
						<div className="btn-box">
							<div className="btn gr">
								<button onClick={backToMyPage}>マイページTOPへ戻る</button>
							</div>
						</div>
					</div>
				)}
			</section>
		</>
	);
});
